import styled from "@emotion/styled";
import { TMeetingRoomDevice } from "apis/meeting-room-device";
import React from "react";
import UI from "@mile-meeting/mile-ui";
import ToolTip from "uis/new-tootip";

const DeviceInfoItem: React.FC<TMeetingRoomDevice> = (device) => {
  const getBatteryIcon =
    device.batteryLevel <= 20 ? "lowBattery" : device.batteryLevel <= 40 ? "midBattery" : "fullBattery";

  const getBatteryIconColor =
    device.batteryLevel <= 20
      ? "var(--global-color-red-70)"
      : device.batteryLevel <= 40
        ? "var(--global-color-yellow-70)"
        : "var(--global-color-green-70)";

  return (
    <Container>
      <DevicePositionContainer>
        <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
          {device.location === "INSIDE" ? "회의실 내부" : "회의실 외부"}
        </UI.Typography>
      </DevicePositionContainer>
      <DeviceIdContainer>
        <UI.Typography type="body01 normal" color="var(--alias-color-label-normal)">
          {device.deviceId}
        </UI.Typography>
      </DeviceIdContainer>
      {device.batteryLevel === null ? (
        <BatteryInfoContainer>
          <UI.Typography type="body02 normal" color="var(--alias-color-label-alternative)">
            배터리/충전 정보 미제공
          </UI.Typography>
          <ToolTip
            text={"태블릿에 설치된 Mile Meeting 앱이 v.2.1.01 이상이어야 확인 가능합니다."}
            position={{
              top: -30,
              left: -40,
            }}
            icon={<UI.Icon name="question" size={16} color="var(--alias-color-label-assistive)" />}
          />
        </BatteryInfoContainer>
      ) : (
        <BatteryInfoContainer>
          <UI.Icon name={getBatteryIcon} color={getBatteryIconColor} size={24} />
          <UI.Typography
            color="var(--alias-color-label-normal)"
            type="body01 normal"
            style={{
              width: "42px",
            }}
          >
            {device.batteryLevel}%
          </UI.Typography>
          <UI.Icon
            name="charge"
            color={device.isBatteryCharging ? "var(--global-color-yellow-70)" : "var(--alias-color-label-assistive)"}
            size={24}
          />
        </BatteryInfoContainer>
      )}
    </Container>
  );
};

export default React.memo(DeviceInfoItem);

const Container = styled.div`
  display: flex;
  padding: 16px 24px;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--alias-color-line-normal);
  gap: 20px;
`;

const DeviceIdContainer = styled.div`
  display: flex;
  min-width: 240px;
  max-width: 400px;
  align-items: center;
  gap: 20px;
  flex: 1 0 0;
`;

const DevicePositionContainer = DeviceIdContainer;

const BatteryInfoContainer = styled.div`
  display: flex;
  min-width: 200px;
  max-width: 320px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
`;
